import { render, staticRenderFns } from "./PaginaSpeseComunicazione.vue?vue&type=template&id=0ddd7a9a"
import script from "./PaginaSpeseComunicazione.vue?vue&type=script&lang=js"
export * from "./PaginaSpeseComunicazione.vue?vue&type=script&lang=js"
import style0 from "./PaginaSpeseComunicazione.vue?vue&type=style&index=0&id=0ddd7a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports